import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaChartLine,
  FaHandshake,
  FaLightbulb,
  FaRocket,
  FaShieldAlt,
  FaStar,
  FaUsers,
} from "react-icons/fa";
import FloatingNavbar from "../components/FloatingNavbar";
import PremiumFooter from "../components/PremiumFooter";
import "./MarketingPages.css";

const stats = [
  { value: "24/7", label: "Visibility" },
  { value: "98%", label: "Team alignment" },
  { value: "1", label: "Command center" },
  { value: "100%", label: "Responsive" },
];

const cards = [
  {
    icon: <FaShieldAlt />,
    title: "Mission",
    desc: "Make operations feel precise, reliable, and calm for fast-moving teams.",
  },
  {
    icon: <FaLightbulb />,
    title: "Vision",
    desc: "Turn everyday workflows into a premium operating experience that scales cleanly.",
  },
  {
    icon: <FaChartLine />,
    title: "Why choose us",
    desc: "Readable metrics and a focused layout keep important signals easy to act on.",
  },
  {
    icon: <FaHandshake />,
    title: "Team workflow",
    desc: "Teams share one premium workspace without extra noise or clutter.",
  },
];

const collaboration = [
  { icon: <FaUsers />, title: "Aligned teams", desc: "One view for leadership, operations, and support." },
  { icon: <FaRocket />, title: "Scale ready", desc: "Prepared to support higher volume and broader operations." },
];

export default function AboutPage() {
  return (
    <main className="marketing-page">
      <div className="marketing-shell">
        <FloatingNavbar />
        <section className="hero-grid">
          <div>
            <span className="section-label">
              <FaStar /> About
            </span>
            <h1>Built for teams that want calm control and premium clarity.</h1>
            <p>
              Techio Hisab brings commerce operations, inventory awareness, and team execution into one refined
              workspace that feels modern, fast, and dependable.
            </p>
            <div className="hero-actions">
              <Link className="button-link button-link--accent" to="/features">
                Explore Features <FaArrowRight />
              </Link>
              <Link className="button-link" to="/workflow">
                View Workflow
              </Link>
            </div>
          </div>

          <div className="glass-card hero-visual">
            <div className="dashboard-grid">
              <article className="dashboard-card">
                <div className="card-icon"><FaShieldAlt /></div>
                <div className="card-copy">
                  <h3>Reliable operations</h3>
                  <p>Stable and elegant workflows built for everyday execution.</p>
                </div>
              </article>
              <article className="dashboard-card">
                <div className="card-icon"><FaChartLine /></div>
                <div className="card-copy">
                  <h3>Actionable insight</h3>
                  <p>Readable business information presented with premium clarity.</p>
                </div>
              </article>
              <article className="dashboard-card">
                <div className="card-icon"><FaUsers /></div>
                <div className="card-copy">
                  <h3>Team-first design</h3>
                  <p>Built to help teams collaborate without friction.</p>
                </div>
              </article>
              <article className="dashboard-card">
                <div className="card-icon"><FaRocket /></div>
                <div className="card-copy">
                  <h3>Scalable growth</h3>
                  <p>Prepared to support higher volume and broader operations.</p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="section-block">
          <div className="section-copy">
            <span className="section-label">Company introduction</span>
            <h2>We design tools that simplify complex commerce work.</h2>
            <p>
              Our mission is to reduce friction across the workday. Our vision is a premium operating layer that helps
              every team move faster with more confidence.
            </p>
          </div>
          <div className="dual-grid">
            {cards.map((card) => (
              <article className="story-card" key={card.title}>
                <div className="card-icon">{card.icon}</div>
                <div className="card-copy">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="section-block">
          <div className="section-copy">
            <span className="section-label">Stats</span>
            <h2>Built to stay fast, focused, and responsive as you scale.</h2>
          </div>
          <div className="stats-grid">
            {stats.map((stat) => (
              <article className="metric-card" key={stat.label}>
                <strong>{stat.value}</strong>
                <div className="metric-copy">
                  <span>{stat.label}</span>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="section-block">
          <div className="section-copy">
            <span className="section-label">Why choose us</span>
            <h2>Elegant visuals backed by practical business utility.</h2>
          </div>
          <div className="feature-grid">
            {cards.slice(0, 2).map((card) => (
              <article className="feature-card" key={card.title}>
                <div className="card-icon">{card.icon}</div>
                <div className="card-copy">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </article>
            ))}
            <article className="feature-card">
              <div className="card-icon"><FaStar /></div>
              <div className="card-copy">
                <h3>Premium finish</h3>
                <p>Glossy glass cards, soft shadows, and high-end spacing across the page.</p>
              </div>
            </article>
          </div>
        </section>

        <section className="section-block">
          <div className="section-copy">
            <span className="section-label">Team collaboration</span>
            <h2>Shared visibility makes coordination feel natural.</h2>
          </div>
          <div className="dual-grid">
            <article className="panel-card">
              <h3>Connected workflow</h3>
              <p>Operations, tracking, and analytics sit in one visual system so every handoff stays clean.</p>
              <div className="preview-curve" />
            </article>
            <div className="workflow-grid">
              {collaboration.map((item) => (
                <article className="help-card" key={item.title}>
                  <div className="card-icon">{item.icon}</div>
                  <strong>{item.title}</strong>
                  <p>{item.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <PremiumFooter />
      </div>
    </main>
  );
}
